import { render, staticRenderFns } from "./updateNameBirthday.vue?vue&type=template&id=287e404e&scoped=true&"
import script from "./updateNameBirthday.vue?vue&type=script&lang=js&"
export * from "./updateNameBirthday.vue?vue&type=script&lang=js&"
import style0 from "./updateNameBirthday.vue?vue&type=style&index=0&id=287e404e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "287e404e",
  null
  
)

export default component.exports